<template>
	<div id="plantGallery">
		<h3>Plant Gallery</h3>
		<br>
		<div v-if="getUser()">
			<b-row class="noselect" style="cursor:pointer">
				<b-col v-for="plant of plants.filter(thisUser).slice().reverse()" cols="3" v-bind:key="plant['.key']"
				>
				<b-card
				style="max-width: 20rem;"
				class="mb-2 onHover"
				v-b-modal="plant['.key']">
				<b-img-lazy :src="plant.url" fluid alt="No image" class="mb-2"></b-img-lazy>
				<b-card-text class="text-center">
					<b-row><b-col><h4><b>{{plant.commonName}}</b></h4></b-col></b-row>
				</b-card-text>
				<b-modal v-bind:id="plant['.key']" size="lg" hide-footer hide-header >
					<b-button class="mb-2" style="float:right" variant="danger" @click="$bvModal.hide(plant['.key'])"><b-icon-x></b-icon-x></b-button>
					<b-img-lazy :src="plant.url" alt="Fluid image" id="modalImg" style="width:100%"></b-img-lazy>
					<b-row class="text-center"><b-col><h4><b>Common Name: {{plant.commonName}}</b></h4></b-col></b-row>
					<b-row class="text-center"><b-col>Scientific Name: {{plant.scientificName}}</b-col></b-row>
					<b-row class="text-center"><b-col>Family: {{plant.family}}</b-col></b-row>
					<b-row class="text-center"><b-col>Origin: {{plant.origin}}</b-col></b-row>
				</b-modal>
			</b-card>
		</b-col>
	</b-row>
</div>

<div v-else>
	<b-row class="noselect" style="cursor:pointer">
		<b-col v-for="plant of plants.slice().reverse()" cols="3" v-bind:key="plant['.key']"
		>
		<b-card
		style="max-width: 20rem;"
		class="mb-2 onHover"
		v-b-modal="plant['.key']">
		<b-img-lazy :src="plant.url" fluid alt="No image" class="mb-2"></b-img-lazy>
		<b-card-text class="text-center">
			<b-row><b-col><h4><b>{{plant.commonName}}</b></h4></b-col></b-row>
		</b-card-text>
		<b-modal v-bind:id="plant['.key']" size="lg" hide-footer hide-header >
			<b-button class="mb-2" style="float:right" variant="danger" @click="$bvModal.hide(plant['.key'])"><b-icon-x></b-icon-x></b-button>
			<b-img-lazy :src="plant.url" alt="Fluid image" id="modalImg" style="width:100%"></b-img-lazy>
			<b-row class="text-center"><b-col><h4><b>Common Name: {{plant.commonName}}</b></h4></b-col></b-row>
			<b-row class="text-center"><b-col>Scientific Name: {{plant.scientificName}}</b-col></b-row>
			<b-row class="text-center"><b-col>Family: {{plant.family}}</b-col></b-row>
			<b-row class="text-center"><b-col>Origin: {{plant.origin}}</b-col></b-row>
		</b-modal>
	</b-card>
</b-col>
</b-row>
</div>


</div>
</template>

<style>
#plantGallery {
	font-family: 'Avenir', Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	color: #2c3e50;
	padding: 50px 50px 50px 50px;
}

.onHover:hover{
	opacity: 0.8;
	color: black;
}
</style>

<script>
import { plantRef } from '../firebase';
export default {
	name: 'butterflies',
	data () {
		return {
			plants: [],
		}
	},
	firebase: {
		plants: plantRef,
	},
	methods: {
		getUser(){
			return this.$parent.activeUser?this.$parent.activeUser.name:'';
		},
		thisUser(plant){
			return (plant.user == this.getUser() || this.getUser() == 'Reiman Gardens')?plant:null
		}
	},
}
</script>